import useInView from '@/hooks/useInView';

interface AnimateSectionProps {
  children: React.ReactNode;
  className?: string;
  animation?: string;
  delay?: number;
}

export default function AnimateSection({
  children,
  className = '',
  animation = 'animate-fade-in-up',
  delay = 0,
}: AnimateSectionProps) {
  const { ref, inView } = useInView(0.12);

  return (
    <div
      ref={ref}
      className={`${className} ${inView ? animation : 'opacity-0'}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}